import React from "react";
import Typography from "@material-ui/core/Typography";

const Label = ({ children, value = "- -" }) => {
  return (
    <Typography>
      <span style={{ color: "var(--text-primary)", lineHeight: 1.8, fontWeight: "700" }}>
        {value + " "}
      </span>
      {children}
    </Typography>
  );
};

export default Label;
